/**
* @name: right-layout-div
* @author: weiyong
* @date: 2023-05-11 18:02
* @description：right-layout-div
* @update: 2023-05-11 18:02
*/
<template>
  <div :class="prefixCls" class="main-panel">
     <header-bar-page></header-bar-page>
    <LayoutContent class="LayoutContent" />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "right-layout-div",
});
</script>

<script lang="ts" setup>
import HeaderBarPage from "./header-bar-page.vue";
import {useDesign} from "@/hooks/web/useDesign";
import LayoutContent from '@/layouts/default/content/index.vue';

const {prefixCls} = useDesign('right-layout-div');
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-right-layout-div';

.scaLayout{
  .LayoutContent{
    height:calc(100% - 72px) !important;
  }
}
.@{prefix-cls} {
  &.main-panel{
    width: 90%;
    flex: 1;
    overflow: hidden;
  }
  .LayoutContent{
    overflow: hidden !important;
  }
}
</style>
